<template>
  <div>
    <table
      v-if="!loading && data.length"
      class="table"
    >
      <thead>
        <tr>
          <th>Ресурс</th>
          <th>Страница</th>
          <th>Тональность</th>
          <th>Рейтинг</th>
          <th>Частотность</th>
          <th>Средняя позиция</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, index) in data"
          :key="index"
        >
          <td>{{ row.site }}</td>
          <td><a :href="row.url">{{ row.url }}</a></td>
          <td>
            <img
              :src="checkTone(row.hostRating) ? require(`../../img/emoticons/${row.hostRating}.svg`) : null"
              :alt="row.hostRating"
            >
          </td> <!-- TODO: помоему в api ключ перепутан с тональностью -->
          <td />
          <td>{{ row.freq }}</td>
          <td>{{ row.avgPos }}</td>
        </tr>
      </tbody>
    </table>
    <no-data v-if="!loading && !data.length" />
  </div>
</template>

<script>
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import analytics from './mixins/analytics'

export default {
  name: 'AnalyticsCommon',
  components: { NoData },
  mixins: [analytics],
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
